import { render, staticRenderFns } from "./index.vue?vue&type=template&id=164b32c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=164b32c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b32c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164b32c2')) {
      api.createRecord('164b32c2', component.options)
    } else {
      api.reload('164b32c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=164b32c2&scoped=true", function () {
      api.rerender('164b32c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/makeRoom/index.vue"
export default component.exports